export default __webpack_public_path__ + "assets/e3cab037268b4e02bef8397a8ba62a78.woff";